import { render, staticRenderFns } from "./ShopReward.vue?vue&type=template&id=48131874&"
import script from "./ShopReward.vue?vue&type=script&lang=js&"
export * from "./ShopReward.vue?vue&type=script&lang=js&"
import style0 from "./ShopReward.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports